import { render, staticRenderFns } from "./ModalStemdoerDetail.vue?vue&type=template&id=23dbe9fa&scoped=true"
import script from "./ModalStemdoerDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalStemdoerDetail.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ModalStemdoerDetail.vue?vue&type=style&index=0&id=23dbe9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23dbe9fa",
  null
  
)

export default component.exports